import axios from 'axios';
import { V1_ADJUSTMENTS_NEW, V1_EXPORT_ADJUSTMENT } from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getAdjustments(params) {
  return axios
    .get(V1_ADJUSTMENTS_NEW, { params, withCredentials: true })
    .catch(reject);
}

export function getExportAdjustment(params) {
  return axios
    .get(V1_EXPORT_ADJUSTMENT, { params, withCredentials: true })
    .catch(reject);
}

export function postAdjustment(data, params) {
  return axios
    .post(V1_ADJUSTMENTS_NEW, data, { params, withCredentials: true })
    .catch(reject);
}
